<template>
  <div class="app-content content ">
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h2 class="content-header-title float-start mb-0">{{ item.id ? 'Edit' : 'New' }} unpaid leaves of absence<br>
              </h2>
            </div>
          </div>
        </div>
        <div class="content-header-right text-md-end col-md-3 col-12 d-md-block d-none">
          <div class="mb-1 breadcrumb-right">
            <a
              class="btn btn-icon btn-secondary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Back to areas & groups list"
              @click="$router.push({name: 'researcher.administration.unpaid-leaves.index'})"
            ><i data-feather="chevron-left" /></a>
            <a
              href="#"
              class="btn btn-icon btn-flat-secondary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Senior call settings"
            ><i data-feather="settings" /></a>
          </div>
        </div>
      </div>

      <div class="content-body content-body--senior-call">
        <div
          v-if="errors != ''"
          class="alert alert-danger mt-1 p-1"
        >
          {{ errors }}
        </div>
        <div class="row">
          <div class="col-12">
            <SearchResearcher :item="item" />

            <div class="card">
              <div
                v-b-toggle="`collapseContent`"
                class="card-header"
              >
                <h3 class="cart-title">
                  <a data-action="collapse">Dates</a>
                </h3>
                <div class="heading-elements">
                  <ul class="list-inline mb-0">
                    <li>
                      <a data-action="collapse"><i data-feather="chevron-down" /></a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="card-content collapse show">
                <b-collapse
                  :id="`collapseContent`"
                  visible
                >
                  <!-- sólo se muestra "show" si hay texto en el textarea -->
                  <div class="card-body">
                    <div class="row">
                      <div class="col-sm-4">
                        <div class="mb-1">
                          <label
                            for=""
                            class="form-label"
                          >Permission date</label>
                          <date-picker
                            v-model="item.permission_date"
                            format="D MMM Y"
                            value-type="format"
                            class="w-100"
                          />
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="mb-1">
                          <label
                            for=""
                            class="form-label"
                          >Concession date</label>
                          <date-picker
                            v-model="item.concession_date"
                            format="D MMM Y"
                            value-type="format"
                            class="w-100"
                          />
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="mb-1">
                          <label
                            for=""
                            class="form-label"
                          >Documents to labour agency</label>
                          <date-picker
                            v-model="item.documents_to_labour_agency"
                            format="D MMM Y"
                            value-type="format"
                            class="w-100"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4">
                        <div class="mb-1">
                          <label
                            for=""
                            class="form-label"
                          >Begin date</label>
                          <date-picker
                            v-model="item.begin_date"
                            format="D MMM Y"
                            value-type="format"
                            class="w-100"
                          />
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="mb-1">
                          <label
                            for=""
                            class="form-label"
                          >End date</label>
                          <date-picker
                            v-model="item.end_date"
                            format="D MMM Y"
                            value-type="format"
                            class="w-100"
                          />
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="mb-1">
                          <label
                            for=""
                            class="form-label"
                          >Status</label>
                          <v-select
                            v-model="item.status"
                            label="status"
                            :options="statuses"
                            :get-option-key="option => option.id"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                </b-collapse>
              </div>
            </div>
            <div class="card">
              <div
                v-b-toggle="`collapseContentInstitutions`"
                class="card-header"
              >
                <h3 class="cart-title">
                  <a data-action="collapse">Institutions</a>
                </h3>
                <div class="heading-elements">
                  <ul class="list-inline mb-0">
                    <li>
                      <a data-action="collapse"><i data-feather="chevron-down" /></a>
                    </li>
                  </ul>
                </div>
              </div>
              <b-collapse
                :id="`collapseContentInstitutions`"
              >
                <div class="card-content collapse show"> <!-- sólo se muestra "show" si hay texto en el textarea -->
                  <div class="card-body">
                    <div class="row">
                      <div class="col-sm-12">
                        <label
                          for=""
                          class="form-label"
                        >Institutions</label>
                        <v-select
                          v-model="item.institutions"
                          label="name"
                          :clearable="false"
                          multiple
                          :options="hosts"
                          :get-option-key="option => option.id"
                          @search="onSearch({ name: $event }, 'institutions/filter')"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </b-collapse>
            </div>

            <IcreaRemarks
              :item="item"
            />

            <AddFile
              :id="6"
              :title="'Support documentation'"
              :type="4"
              :files="item.files_"
            />

            <InternalNotes
              :notes="item.notes"
              @saveNewNote="saveNewNote"
            />
          </div>
        </div>

        <div class="page-actions">
          <button
            v-if="!sending"
            id="type-success"
            class="btn btn-success"
            @click="save"
          >
            <i data-feather="save" />
            <span class="ms-25 align-middle">Save and Exit</span>
          </button>
          <button
            v-else
            class="btn btn-outline-success"
            type="button"
            disabled=""
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            />
            <span class="ms-25 align-middle">Saving...</span>
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { BCollapse } from 'bootstrap-vue'
import vSelect from 'vue-select'
import { mapGetters } from 'vuex'
import InternalNotes from '@/views/back/partials/components/InternalNotes.vue'
import DatePicker from 'vue2-datepicker'
import IcreaRemarks from '@/views/back/partials/components/IcreaRemarks.vue'
import AddFile from '../../../admin/senior-call/components/AddFile.vue'
import SearchResearcher from '../../../partials/components/SearchResearcher.vue'
import 'vue2-datepicker/index.css'

export default {
  components: {
    AddFile,
    SearchResearcher,
    InternalNotes,
    IcreaRemarks,
    vSelect,
    DatePicker,
    BCollapse,
  },
  data() {
    return {
      unpaidLeaveId: this.$route.params.id,
      dateAlert: 0,
      sending: false,
      errors: '',
    }
  },
  computed: {
    ...mapGetters({
      item: 'unpaidLeaves/item',
      statuses: 'status/statuses',
      hosts: 'institutions/institutions',
    }),
  },
  async mounted() {
    if (this.unpaidLeaveId) {
      await this.$store.dispatch('unpaidLeaves/fetchId', this.unpaidLeaveId)
    } else {
      await this.$store.dispatch('unpaidLeaves/cleanType')
    }

    this.$store.dispatch('status/filterStatus', 'Unpaid leaves')
  },
  methods: {
    saveFiles(files) {
      this.item.files_ = files.data
    },
    async save() {
      this.sending = true
      try {
        if (this.unpaidLeaveId) {
          await this.$store.dispatch('unpaidLeaves/update', { id: this.unpaidLeaveId, data: this.item })
        } else {
          await this.$store.dispatch('unpaidLeaves/create', this.item)
        }
        this.errors = ''
      } catch (e) {
        this.errors = e.response.data.message
      }

      if (this.errors === '' && this.item.id) {
        Vue.swal('The Unpaid leaves of absense has been saved correctly!', '', 'success').then(() => {
          this.$router.push({ name: 'researcher.administration.unpaid-leaves.index' })
        })
      } else {
        // Vue.swal
      }

      this.sending = false
    },
    saveNewNote(note) {
      this.item.notes.push(note)
    },
    async onSearch(search, store) {
      search.active = true
      if (search.name !== '') {
        await this.$store.dispatch(store, search)
      }
    },
  },
}
</script>
